// extracted by mini-css-extract-plugin
export default {"container":"SignUp_container__uXgMl","links":"SignUp_links__EBQe7","layout":"SignUp_layout__rbP9J"};